import React from 'react';
import { useSelector } from 'react-redux';
import { selectUiState } from '../../redux/slices/ui';
import Receipt from './index';
import ReceiptV2 from './receipt-v2';
import GuestShell from '../guest-shell';

const ReceiptSwitch = props => {
  const ui = useSelector(selectUiState);

  return ui.isBookingEngine ? (
    <GuestShell
      activeTab="stay"
      bookingCode={props.match.params.booking_code}
      slug={props.match.params.slug}
    >
      <ReceiptV2 {...props} />
    </GuestShell>
  ) : (
    <Receipt {...props} />
  );
};

export default ReceiptSwitch;
